// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__262Ta","right":"Footer_right__1XwwQ","buttons":"Footer_buttons__2HGDg"};